import backend from "api/api"
import Breadcrumbs from "components/Common/Breadcrumb"
import React from "react"
import { MetaTags } from "react-meta-tags"
import { Button, Col, Container, Row } from "reactstrap"
import { toast, ToastContainer } from "react-toastify"
import { Link, useHistory } from "react-router-dom"
import { useState } from "react"
export default function NewTradeType() {
  const [state, setState] = useState({ activityName: "" })
  const history = useHistory()
  const handleActivity = e => {
    const { name, value } = e.target

    setState(prevState => ({
      ...prevState,
      [name]: value,
    }))
  }
  const postActivity = async () => {
    const trimmedActivity = state.activityName.trim()
    try {
      const body = {
        name: trimmedActivity,
        status: "active",
      }
      if (!trimmedActivity) {
        toast.error("Activity Name is Required")
      } else {
        const resp = await backend.post("/api/type", body)
        setTimeout(() => history.push("/triptrader/tradetype"), 1000)
        toast.success(resp?.data?.message)
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || error)
    }
  }

  const breadcrumbItems = [
    { title: "Dashboard", path: "/triptrader/dashboard" },
    { title: "Create Trade Type", path: "#" },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> New Trade Type | Trip Trader</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                {/* <h6 className="page-title WebHeader">Freemium Customers </h6> */}
                <Breadcrumbs breadcrumbItems={breadcrumbItems} />

                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active"></li>
                </ol>
              </Col>
            </Row>
          </div>
          <Row>
            <Col xs={12} sm={12} md={6}>
              <label
                htmlFor="example-text-input"
                className=" col-form-label"
              >
                New Trade Type
              </label>
              <input
                className="form-control"
                type="text"
                name="activityName"
                onChange={handleActivity}
              />
            </Col>
          </Row>
          <Row
            style={{
              marginTop: "1rem",
            }}
          >
            <Col xs={4} sm={3} md={1}>
              <Button
                color="success"
                className="btn btn-success waves-effect waves-light"
                onClick={postActivity}
              >
                Save
              </Button>{" "}
              <ToastContainer />
            </Col>
            <Col xs={3} sm={3} md={6}>
              <Link
                to="/triptrader/tradetype"
                color="secondary"
                className="btn btn-secondary waves-effect"
              >
                Cancel
              </Link>{" "}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
